"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
const constants = {
  URGENCY_TAG_TYPE: {
    THREE_PLUS_DAYS: '3+ days',
    TWO_DAYS: '2 days',
    ONE_DAY: '1 day',
    HOURS: 'Hours',
    EXTENDED: 'Extended',
    UPCOMING: 'Upcoming',
    TIMER: 'Timer'
  },
  DEFAULT_TIMER_META_CONFIG: {
    comingSoonLabel: '',
    extendedLabel: '',
    hoursLabel: '',
    todayOnlyLabel: '',
    todayAndTomorrowLabel: '',
    endsTomorrowLabel: '',
    endsTodayLabel: '',
    endsLabel: '',
    endsInLabel: '',
    offerEndedLabel: ''
  }
};
var _default = exports.default = constants;